import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}
const Footer = props => {
  const location = useLocation()
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentYear(new Date().getFullYear())
    }, 1000) // Update every second (optional)

    return () => clearInterval(interval) // Cleanup interval on unmount
  }, [])
  return (
    <footer className='site_footer footer_layout_3'>
      <div className='footer_main_content bg-dark'>
        <div className='container'>
          <div className='row mb-5'>
            <div className='col-lg-7'>
              <div className='heading_block mb-lg-0 text-white mb-0'>
                <h2 className='heading_text mb-1'>
                  Tell us how can we serve you?
                </h2>
                <p className='heading_description mb-0 text-uppercase'>
                  Let's collaborate and make lives easier.
                </p>
              </div>
            </div>
            {/* <div className='col-lg-5'>
              <div className='social_wrap'>
                <h3 className='footer_info_title text-white mb-4 mb-md-0'>
                  Apps
                </h3>
                <ul
                  className='social_icons_block unordered_list flex-nowrap'
                  style={{ maxWidth: '320px' }}
                >
                  <li>
                    <a
                      href='https://play.google.com/store/apps/details?id=com.cloud.drrived'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='d-flex align-items-center justify-content-center w-100 h-auto px-3 py-2 text-center text-white bg-white hover-bg-light rounded-3'
                    >
                      <svg
                        className='w-25'
                        viewBox='-9 0 274 274'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g>
                          <path
                            d='M188.81319,178.874645 C221.272218,161.051727 245.880297,147.470853 248.001319,146.415618 C254.78648,142.806714 261.79324,133.256838 248.001319,125.838536 C243.548228,123.506467 219.573289,110.347687 188.81319,93.3795092 L146.171146,136.443648 L188.81319,178.874645 Z'
                            fill='#FFD900'
                          />
                          <path
                            d='M146.171146,136.443648 L10.3940643,273.286517 C13.5808739,273.708611 17.1792251,272.864423 21.4212696,270.532353 C30.3274526,265.657168 124.739324,214.098388 188.81319,178.885198 L146.171146,136.443648 Z'
                            fill='#F43249'
                          />
                          <path
                            d='M146.171146,136.443648 L188.81319,93.5905562 C188.81319,93.5905562 30.9711459,7.45172685 21.4212696,2.36549437 C17.8229184,0.233919759 13.7919209,-0.399221214 10.1830173,0.233919759 L146.171146,136.443648 Z'
                            fill='#00EE76'
                          />
                          <path
                            d='M146.171146,136.443648 L10.1830173,0.233919759 C4.6641385,1.51075405 0,6.38593954 0,16.3579099 C0,32.270853 0,244.003747 0,257.162527 C0,266.290309 3.60890354,272.864423 10.3940643,273.497564 L146.171146,136.443648 Z'
                            fill='#00D3FF'
                          />
                        </g>
                      </svg>
                      <div className='d-flex flex-column ms-2 text-start'>
                        <span className='text-black small'>Get it on</span>
                        <span className='text-black fw-semibold'>
                          Play Store
                        </span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      href='https://apps.apple.com/in/app/drrived/id6742740763'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='d-flex align-items-center justify-content-center w-100 h-auto px-3 py-2 text-center text-white bg-white hover-bg-light rounded-3'
                    >
                      <svg
                        className='w-25'
                        viewBox='0 0 40 45'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0)'>
                          <path
                            d='M32.6226 23.7016C32.6026 20.0267 34.2591 17.253 37.6118 15.2103C35.7359 12.5167 32.902 11.0347 29.1601 10.7443C25.6177 10.464 21.7461 12.8171 20.3292 12.8171C18.8324 12.8171 15.3998 10.8445 12.7057 10.8445C7.13769 10.9346 1.22048 15.3004 1.22048 24.1822C1.22048 26.8057 1.69945 29.516 2.65738 32.3131C3.93461 35.988 8.54465 45 13.3542 44.8498C15.8688 44.7897 17.645 43.0574 20.9179 43.0574C24.091 43.0574 25.7375 44.8498 28.5414 44.8498C33.3909 44.7797 37.5619 36.5888 38.7793 32.9039C32.2733 29.8298 32.6226 23.8919 32.6226 23.7016ZM26.9748 7.25968C29.6989 4.01535 29.4494 1.06142 29.3696 0C26.9648 0.140187 24.1808 1.64219 22.5943 3.49466C20.848 5.4773 19.8203 7.93058 20.0398 10.6943C22.6442 10.8945 25.019 9.55274 26.9748 7.25968Z'
                            fill='black'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0'>
                            <rect width='40' height='45' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className='d-flex flex-column ms-2 text-start'>
                        <span className='text-black small'>Get it on</span>
                        <span className='text-black fw-semibold'>
                          App Store
                        </span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div> */}
            {/* <div className="col-lg-5">
              <div className="social_wrap">
                <h3 className="footer_info_title text-white mb-4 mb-md-0">Follow Us</h3>
                <ul className="social_icons_block unordered_list">
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <i className="fa-brands fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <i className="fa-brands fa-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <i className="fa-brands fa-youtube"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>

          <div className='row justify-content-lg-between pt-lg-4'>
            <div className='col-lg-3 col-md-6 col-sm-6'>
              <div className='row'>
                <div className='col-md-12 col-sm-12'>
                  <div className='footer_widget'>
                    <h3 className='footer_info_title'>Start a Conversation</h3>
                    <ul className='icon_list unordered_list_block'>
                      <li>
                        <a href='mailto:contact@drrived.com'>
                          <span className='icon_list_text'>
                            contact@drrived.com
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href='mailto:contact@drrived.com'>
                          <span className='icon_list_text'>
                            support@drrived.com
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                  <h3 className='footer_info_title mt-4'>
                  Download Our App
                  </h3>
                <div className='d-xxl-flex d-md-block d-flex gap-2 mb-4'>

                  <a
                    href='https://play.google.com/store/apps/details?id=com.cloud.drrived'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='d-flex align-items-center justify-content-center w-100 h-auto px-3 py-2 text-center text-white bg-white hover-bg-light rounded-3 mb-0 mb-xxl-0 mb-xl-2 mb-sm-2'
                    style={{maxWidth: '150px'}}
                  >
                    <svg
                      className='w-25'
                      viewBox='-9 0 274 274'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g>
                        <path
                          d='M188.81319,178.874645 C221.272218,161.051727 245.880297,147.470853 248.001319,146.415618 C254.78648,142.806714 261.79324,133.256838 248.001319,125.838536 C243.548228,123.506467 219.573289,110.347687 188.81319,93.3795092 L146.171146,136.443648 L188.81319,178.874645 Z'
                          fill='#FFD900'
                        />
                        <path
                          d='M146.171146,136.443648 L10.3940643,273.286517 C13.5808739,273.708611 17.1792251,272.864423 21.4212696,270.532353 C30.3274526,265.657168 124.739324,214.098388 188.81319,178.885198 L146.171146,136.443648 Z'
                          fill='#F43249'
                        />
                        <path
                          d='M146.171146,136.443648 L188.81319,93.5905562 C188.81319,93.5905562 30.9711459,7.45172685 21.4212696,2.36549437 C17.8229184,0.233919759 13.7919209,-0.399221214 10.1830173,0.233919759 L146.171146,136.443648 Z'
                          fill='#00EE76'
                        />
                        <path
                          d='M146.171146,136.443648 L10.1830173,0.233919759 C4.6641385,1.51075405 0,6.38593954 0,16.3579099 C0,32.270853 0,244.003747 0,257.162527 C0,266.290309 3.60890354,272.864423 10.3940643,273.497564 L146.171146,136.443648 Z'
                          fill='#00D3FF'
                        />
                      </g>
                    </svg>
                    <div className='d-flex flex-column ms-2 text-start'>
                      <span className='text-black small'>Get it on</span>
                      <span className='text-black fw-semibold'>Play Store</span>
                    </div>
                  </a>
                  <a
                    href='https://apps.apple.com/in/app/drrived/id6742740763'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='d-flex align-items-center justify-content-center w-100 h-auto px-3 py-2 text-center text-white bg-white hover-bg-light rounded-3'
                    style={{maxWidth: '150px'}}
                  >
                    <svg
                      className='w-25'
                      viewBox='0 0 40 45'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g clipPath='url(#clip0)'>
                        <path
                          d='M32.6226 23.7016C32.6026 20.0267 34.2591 17.253 37.6118 15.2103C35.7359 12.5167 32.902 11.0347 29.1601 10.7443C25.6177 10.464 21.7461 12.8171 20.3292 12.8171C18.8324 12.8171 15.3998 10.8445 12.7057 10.8445C7.13769 10.9346 1.22048 15.3004 1.22048 24.1822C1.22048 26.8057 1.69945 29.516 2.65738 32.3131C3.93461 35.988 8.54465 45 13.3542 44.8498C15.8688 44.7897 17.645 43.0574 20.9179 43.0574C24.091 43.0574 25.7375 44.8498 28.5414 44.8498C33.3909 44.7797 37.5619 36.5888 38.7793 32.9039C32.2733 29.8298 32.6226 23.8919 32.6226 23.7016ZM26.9748 7.25968C29.6989 4.01535 29.4494 1.06142 29.3696 0C26.9648 0.140187 24.1808 1.64219 22.5943 3.49466C20.848 5.4773 19.8203 7.93058 20.0398 10.6943C22.6442 10.8945 25.019 9.55274 26.9748 7.25968Z'
                          fill='black'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0'>
                          <rect width='40' height='45' fill='white' />
                        </clipPath>
                      </defs>
                    </svg>
                    <div className='d-flex flex-column ms-2 text-start'>
                      <span className='text-black small'>Get it on</span>
                      <span className='text-black fw-semibold'>App Store</span>
                    </div>
                  </a>
                </div>
                {/* <div className="col-md-6 col-sm-6">
                  <div className="footer_widget">
                    <h3 className="footer_info_title">Call Us:</h3>
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <a href="tel:+91 9851198555">
                          <span className="icon_list_text">
                            +91 9851198555
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
            <div className='col-lg-3 col-md-6 col-sm-6'>
              <div className='footer_widget'>
                <h3 className='footer_info_title'>Useful Links</h3>
                <ul className='icon_list unordered_list_block'>
                  {/* <li>
                    <a onClick={ClickHandler} href="https://www.thevpgroup.in/careers" target="_blank" rel="noopener noreferrer">
                      <span className="icon_list_text">
                        Careers
                      </span>
                    </a>
                  </li> */}
                  {/* <li>
                      <Link onClick={ClickHandler} to="/team">
                        <span className="icon_list_text">
                          Our Team
                        </span>
                      </Link>
                    </li> */}
                  {/* <li>
                    <Link onClick={ClickHandler} to="/portfolio">
                      <span className="icon_list_text">
                        Latest Projects
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/portfolio">
                      <span className="icon_list_text">
                        Awarded portfolio
                      </span>
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to='/contact'
                      className={
                        location.pathname === '/contact' ? 'active-link' : ''
                      }
                    >
                      <span className='icon_list_text'>Contact Us</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to='/about'
                      className={
                        location.pathname === '/about' ? 'active-link' : ''
                      }
                    >
                      <span className='icon_list_text'>About Us</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to='/privacy-policy'
                      className={
                        location.pathname === '/privacy-policy'
                          ? 'active-link'
                          : ''
                      }
                    >
                      <span className='icon_list_text'>Privacy Policy</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to='/terms-and-conditions'
                      className={
                        location.pathname === '/terms-and-conditions'
                          ? 'active-link'
                          : ''
                      }
                    >
                      <span className='icon_list_text'>
                        Terms And Conditions
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-lg-5'>
              <div className='footer_widget'>
                <h3 className='footer_info_title'>Address</h3>
                <ul className='icon_list unordered_list_block'>
                  <li className='flex-column gap-0'>
                    <span
                      className='d-block w-100'
                      style={{ color: '#1d58eb', fontSize: '15px' }}
                    >
                      Punjab
                    </span>
                    <span className='icon_list_text text-white d-block w-100'>
                      B-70, Industrial Area, Phase 7, Sahibzada Ajit Singh Nagar
                      (Mohali), Punjab 160055
                    </span>
                  </li>
                  <li className='flex-column gap-0'>
                    <span
                      className='d-block w-100'
                      style={{ color: '#1d58eb', fontSize: '15px' }}
                    >
                      Delhi NCR (National Capital Region)
                    </span>
                    <span className='icon_list_text text-white d-block w-100'>
                      A -24, 3rd Floor, Sector-63, NOIDA, Uttar Pradesh 201301
                    </span>
                  </li>
                  <li className='flex-column gap-0'>
                    <span
                      className='d-block w-100'
                      style={{ color: '#1d58eb', fontSize: '15px' }}
                    >
                      Maharashtra
                    </span>
                    <span className='icon_list_text text-white d-block w-100'>
                      Office No. 211, Shalimar Morya Park, 1079, New Link Rd,
                      Adarsh Nagar, Jogeshwari West, Mumbai, Maharashtra 400102
                    </span>
                  </li>
                  {/* <li>
                    <Link onClick={ClickHandler} to="/home_business_consulting">
                      <span className="icon_list_text">
                        201 Spear Street,
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/home_business_consulting">
                      <span className="icon_list_text">
                        San Francisco, CA, USA
                      </span>
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footer_bottom bg-primary text-white'>
        <div className='container d-md-flex justify-content-between align-items-md-center gap-2'>
          <p className='copyright_text mb-2 mb-md-0'>
            Copyright © {currentYear} Drrived, All rights reserved.
          </p>
          <p className='copyright_text m-0'>
            Powered by Digitax India Communications Private Limited
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
